import { FormEvent, useState } from 'react';

import { ITokenSale, useRejectTokenSaleMutation } from '@entities/trades/token-sell';
import { FormItemWithError } from '@shared/components/Form';
import { useModal } from '@shared/components/Modal';

interface IProps<T> {
  tokenSale: T;
  refetch: () => void;
}

export const RejectTokenSale = <T extends ITokenSale>({ tokenSale, refetch }: IProps<T>) => {
  const { id } = tokenSale;

  const [reason, setReason] = useState('no_transaction_in_statement');

  const [rejectTokenSale, { isLoading, isError, error, isSuccess }] = useRejectTokenSaleMutation();

  const { closeModal } = useModal();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const result = await rejectTokenSale({
        id,
        reason,
      });

      if ('data' in result) {
        closeModal();
        refetch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <h2>Reject Token Sale</h2>
      <form className='popup-form' onSubmit={handleSubmit}>
        <FormItemWithError name='reason' label='Reason' isError={isError} error={error}>
          <select
            name='reason'
            id='reason'
            defaultValue={reason}
            onChange={e => setReason(e.target.value)}
          >
            <option value='manual_rejection'>Manual rejection</option>
            <option value='no_transaction_in_statement'>No transaction in statement</option>
            <option value='amount_mismatch'>Amount mismatch</option>
          </select>
        </FormItemWithError>

        {isSuccess && <div className='form-success'>Successfully rejected</div>}

        <div className='form-submit'>
          <button type='submit' disabled={isLoading}>
            Reject
          </button>
          <button type='button' className='secondary-btn' onClick={closeModal}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};
